import { Field } from "formik";
import TimeField from "../components/TimeField/TimeField";
import { useFormInputHelpers } from "./useFormInputHelpers";

const FormTimeInput = ({
  name,
  onChange,
  shouldHaveErrorBehaviorAfterSubmit,
  helperText,
  ...props
}) => {
  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
    helperText,
  });

  return (
    <Field
      name={name}
      as={TimeField}
      helperText={finalHelperText}
      isError={shouldDisplayError}
      {...(typeof onChange === "function" ? { onChange } : {})}
      {...props}
    />
  );
};

export default FormTimeInput;
